"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductValuesContainer = void 0;
const react_1 = __importStar(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
const ui_components_1 = require("@groupby/ui-components");
const debounce_1 = __importDefault(require("debounce"));
const product_values_selector_styles_1 = require("./product-values-selector.styles");
const hooks_1 = require("../../../../../../hooks");
const localization_1 = require("../../../../../../localization");
const ProductValuesContainer = ({ value, onOptionChange }) => {
    const [suggestions, setSuggestions] = (0, react_1.useState)([]);
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const token = (0, hooks_1.useToken)();
    const handleUpdateAutocompleteSuggestions = (0, debounce_1.default)((inputValue) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const values = yield client.formalAttributeValues.getMany({
                filter: new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `name`, '=~', new RegExp(`^${inputValue}.*`, 'ig'))),
            });
            // it's possible that multiple values have the same name
            // this reduce function combines values with the same name into a single option
            // the option value is a stringified array of the value ids
            const options = (_a = values === null || values === void 0 ? void 0 : values.reduce((transformedOptions, { id, name }) => {
                const existingItem = transformedOptions.find((item) => item.label === name);
                if (existingItem) {
                    const existingIds = JSON.parse(existingItem.value);
                    existingIds.push(id);
                    existingItem.value = JSON.stringify(existingIds);
                }
                else {
                    transformedOptions.push({ label: name, value: JSON.stringify([id]) });
                }
                return transformedOptions;
            }, [])) !== null && _a !== void 0 ? _a : [];
            setSuggestions(options);
        }
        catch (e) {
            addError(t({ key: 'ADVANCED_FILTER_VLAUE_LOADING_ERROR' }));
        }
    }), 300);
    const getSelectionLabel = (selected) => { var _a; return (_a = suggestions.find((option) => option.value === selected)) === null || _a === void 0 ? void 0 : _a.label; };
    const derivedInputValue = (0, react_1.useMemo)(() => inputValue || (value && getSelectionLabel(value)) || '', [value, inputValue, suggestions]);
    (0, react_1.useEffect)(() => {
        if (token) {
            void handleUpdateAutocompleteSuggestions(inputValue);
        }
    }, [derivedInputValue, token]);
    const handleInputChange = (_e, newValue, _reason) => {
        setInputValue(newValue);
    };
    const handleOnChange = (_e, option, _reason, _details) => {
        var _a;
        const selectedOption = Array.isArray(option) ? option[0] : option;
        if (typeof selectedOption === 'string') {
            onOptionChange(selectedOption);
            return;
        }
        onOptionChange((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && _a !== void 0 ? _a : '');
    };
    return (react_1.default.createElement(product_values_selector_styles_1.StyledProductAutocompleteSelector, { onInputChange: handleInputChange, InputProps: { placeholder: t({ key: 'VALUE' }) }, onChange: handleOnChange, options: suggestions, inputValue: derivedInputValue, value: value !== null && value !== void 0 ? value : '', variant: 'outlined', selectOnFocus: true, background: ui_components_1.baseColors.white }));
};
exports.ProductValuesContainer = ProductValuesContainer;
exports.default = exports.ProductValuesContainer;
